export const tracks = [
  {
    "act": "Acte premier",
    "scene": "Scène 1",
    "src": "/audio/acte-1-scene-1.mp3",
    "duration": 222
  },
  {
    "act": "Acte premier",
    "scene": "Scène 2",
    "src": "/audio/acte-1-scene-2.mp3",
    "duration": 168
  },
  {
    "act": "Acte premier",
    "scene": "Scène 3",
    "src": "/audio/acte-1-scene-3.mp3",
    "duration": 134
  },
  {
    "act": "Acte premier",
    "scene": "Scène 4",
    "src": "/audio/acte-1-scene-4.mp3",
    "duration": 169
  },
  {
    "act": "Acte premier",
    "scene": "Scène 5",
    "src": "/audio/acte-1-scene-5.mp3",
    "duration": 181
  },
  {
    "act": "Acte II",
    "scene": "Scène 1",
    "src": "/audio/acte-2-scene-1.mp3",
    "duration": 144
  },
  {
    "act": "Acte II",
    "scene": "Scène 2",
    "src": "/audio/acte-2-scene-2.mp3",
    "duration": 123
  },
  {
    "act": "Acte II",
    "scene": "Scène 3",
    "src": "/audio/acte-2-scene-3.mp3",
    "duration": 205
  },
  {
    "act": "Acte II",
    "scene": "Scène 4",
    "src": "/audio/acte-2-scene-4.mp3",
    "duration": 180
  },
  {
    "act": "Acte II",
    "scene": "Scène 5",
    "src": "/audio/acte-2-scene-5.mp3",
    "duration": 97
  },
  {
    "act": "Acte III",
    "scene": "Scène 1",
    "src": "/audio/acte-3-scene-1.mp3",
    "duration": 92
  },
  {
    "act": "Acte III",
    "scene": "Scène 2",
    "src": "/audio/acte-3-scene-2.mp3",
    "duration": 109
  },
  {
    "act": "Acte III",
    "scene": "Scène 3",
    "src": "/audio/acte-3-scene-3.mp3",
    "duration": 415
  },
  {
    "act": "Acte III",
    "scene": "Scène 4",
    "src": "/audio/acte-3-scene-4.mp3",
    "duration": 251
  },
  {
    "act": "Acte III",
    "scene": "Scène 5",
    "src": "/audio/acte-3-scene-5.mp3",
    "duration": 130
  }
];
